import { Parcel } from 'app/core/app.model';

export const fullAddress = (parcel: Parcel): string => {
    return ([
        'addressShort',
        'municipality',
        'regionShort',
        'postalCode',
    ] as const)
        .map(k => parcel[k])
        .filter(v => !!v)
        .join(' ');
};
